// Ported verbatim from desktop/src/renderer/src/lib/avatar.ts.
// Keeps chat avatar labels/colors identical between desktop and web.
const AVATAR_TONES = ["blue", "green", "orange", "red"] as const;
const AVATAR_TONE_CLASSES = {
	blue: "bg-gradient-to-br from-sky-400 to-blue-600",
	green: "bg-gradient-to-br from-emerald-400 to-emerald-700",
	orange: "bg-gradient-to-br from-amber-400 to-orange-600",
	red: "bg-gradient-to-br from-rose-400 to-red-600",
} as const;

export const getAvatarLabel = (value: string) => {
	const parts = value.trim().split(/\s+/).filter(Boolean);
	if (parts.length === 0) return "TG";
	return parts
		.slice(0, 2)
		.map((part) => part[0]?.toUpperCase() ?? "")
		.join("");
};

export const getAvatarTone = (value: string) => {
	const seed = [...value].reduce(
		(total, character) => total + character.charCodeAt(0),
		0,
	);
	return AVATAR_TONES[seed % AVATAR_TONES.length];
};

export const getAvatarToneClass = (value: string) =>
	AVATAR_TONE_CLASSES[getAvatarTone(value)];
